import { useToast, toast } from "@/app/_module/hooks/use-toast";

export { useToast, toast };
